import lodashGet from 'lodash/get';
import T from 'i18n-react';
import XRegExp from 'xregexp';
import { ISSUE_ATTRIBUTE_NAMES } from '../constants/issue-attribute-names';
import { STATUS_OPEN } from '../constants/status-types';

export const presenceValidator = (val) =>
  typeof val !== 'undefined' && val !== null && (!val.trim || val.trim()) && val.length;

export const getMandatoryFields = (selectedTransition) => {
  const mandatoryFields = [ISSUE_ATTRIBUTE_NAMES.TITLE, ISSUE_ATTRIBUTE_NAMES.STATUS];

  // TODO: remove this flag once the BE will return it in users/me as permitted field for open status
  // https://jira.autodesk.com/browse/BTLV-11822
  if (selectedTransition && selectedTransition.status === STATUS_OPEN) {
    mandatoryFields.push(ISSUE_ATTRIBUTE_NAMES.CUSTOM_IDENTIFIER);
  }

  return mandatoryFields.concat(lodashGet(selectedTransition, 'additionalRequiredAttributes', []));
};

/**
 * Validates that an input is a number
 */
const validateNumericalValue = (text) =>
  !(!text || (text.length === 1 && text[0] === '-') || !isNaN(text)) &&
  T.translate('validationMessages.nanError');

/**
 * Validates a string (supposedly numeric) has no space(s)
 */
const validateNumericHasNoSpace = (text) =>
  !(!text || !text.includes(' ')) && T.translate('validationMessages.numericSpaceError');

/**
 * Validates a numeric string has no commas after a number
 */
const validateNumericHasNoComma = (text) =>
  !(!text || !/[0-9],/g.test(text)) && T.translate('validationMessages.numericCommaError');

/**
 * Validates a numeric string has no double periods
 */
const validateNumericHasNoDoublePeriods = (text) =>
  !(!text || !(text.replace(/[^.]/g, '').length > 1)) &&
  T.translate('validationMessages.numericDoublePeriodError');

/**
 * Validates a numeric string doesn't include numbers and letters
 */
const validateNumericEdgeCase = (text) =>
  !(!text || !(isNaN(text) && /\d/.test(text))) &&
  T.translate('validationMessages.numericValidNumber');

/**
 * Validates a numeric string doesn't include more than {maxLength} digits after decimal point
 * @param text
 * @param maxLength
 */
const validateNumericMaxFloat = (text, maxLength) => {
  const expression = new RegExp(`^-?\\d*\\.?\\d{0,${maxLength}}$`);
  return (
    !(!text || expression.test(text)) &&
    T.translate('validationMessages.numericMaxFloat', { maxLength })
  );
};

/**
 * Validates a numeric string doesn't include more than {maxLength} characters
 * @param text
 * @param maxLength
 */
const validateNumericMaxLength = (text, maxLength) =>
  !(!text || text.length <= maxLength) &&
  T.translate('validationMessages.numericMaxLength', { maxLength });

export const commonNumericalValidations = (text) =>
  validateNumericHasNoSpace(text) ||
  validateNumericHasNoComma(text) ||
  validateNumericHasNoDoublePeriods(text) ||
  validateNumericEdgeCase(text) ||
  validateNumericalValue(text) ||
  validateNumericMaxFloat(text, 5) ||
  validateNumericMaxLength(text, 15);

export const rfiCustomIdentifierAllowedCharactersValidator = (text) => {
  const expression = XRegExp('^[-_,./\\\\0-9\\p{L} ]*$');
  return expression.test(text);
};

export const rfiCustomIdentifierMaxLengthValidator = (text, maxLength) =>
  !text || text.length <= maxLength;

export const isDatePastValidator = (value, isMandatory = false) => {
  if (!value) {
    return !isMandatory;
  }
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return now < Date.parse(value);
};
